import { useState, useContext, useEffect } from "react";
import UploadFileIcon from '@mui/icons-material/UploadFile';
import useLoading from "../../../Hooks/useLoading";
import { PleaImpactChangedSelect, GetPleaImpactbyPleaId, UploadPleaImpact, GetPleaImpactFilesById, DeletePleaImpactsFile, DownloadPleaImpactsFile } from "../../../API/PleaImpactAPI";
import { IResponseProps } from "../../../Interfaces/IResponseProps";
import { useToast } from '../../../antd/hooks/toast';
import { useLocation, useNavigate } from "react-router-dom";
import { AuthContext } from "../../../Contexts/AuthContext";
import { Button, Radio, Table, TableColumnsType, Typography, UploadProps } from "antd";
import FIDragger from "../../../antd/components/dragger/dragger";
import { CloudDownloadOutlined, DeleteOutlined, FileImageOutlined, QuestionCircleOutlined } from "@ant-design/icons";
import ModalPleaSocioEnvironmentalInfo from "../../../antd/components/Plea/PleaSocioEnvironmental/Modal";
import { filterExistingFields } from "../../../antd/utils/filter";
import { set } from "react-hook-form";

interface ImpactTab {
    pleaId: string; 
    companyId: string; 
}

export const ImpactTab = ({ pleaId, companyId}: ImpactTab) => {
    const navigate = useNavigate()
    const { loading, toggleLoading } = useLoading();
    const toast = useToast();
    const location = useLocation();
    const { state } = location;
    const { userEmail } = useContext(AuthContext);

    const [dialogHelp, setDialogHelp] = useState(false);
    const [physicalImpact, setPhysicalImpact] = useState<number>();
    const [socialImpact, setSocialImpact] = useState<number>();
    const [socioEnvironmental, setSocioEnvironmental] = useState<number>();
    const [bioticImpact, setBioticImpact] = useState<number>();
    const [fileNames, setFileNames] = useState<string[] | null>();
    const [files, setFiles] = useState<File[]>([]);
    const [filesList, setFilesList] = useState<[]>([]);
    const urlPleaImpacts = `${companyId}/pleaImpacts/${state}`;

    function constructImpactModel({ id, title, description, value }: { id: string, title: string, description: string, value: number | undefined }) {
        return (
            <div style={{ display: 'flex', flexDirection: 'column', margin: '16px 0px 0px 0px' }}>
                <Typography style={{ color: '#000085', fontSize: '18px' }}>{title}</Typography>
                <div style={{ alignItems: 'center' }}>
                    <Typography style={{ color: 'var(--color-grey)', fontSize: '16px', alignSelf: 'center' }}>{description}</Typography>
                    <Radio.Group
                        value={value}
                        onChange={(event) => handleChangeselect(event, id)}
                        style={{ marginTop: '16px' }}>
                        <Radio  value={0} checked={value === 1}>Sim</Radio>
                        <Radio  value={1} checked={value === 0}>Não</Radio>
                    </Radio.Group>
                </div>
            </div>
        )
    }
    
    const getPleaImpacts = async () => {
        if (pleaId){
            try {
                await GetPleaImpactbyPleaId(pleaId).then((resp: IResponseProps) => {
                    if (resp.statusCode === 200) {
                        const valueSocialImpact = resp.data.socialImpact == true ? 1 : resp.data.socialImpact == false ? 0 : undefined;
                        const valuePhysicalImpact = resp.data.physicalImpact == true ? 1 : resp.data.physicalImpact == false ? 0 : undefined;
                        const valueBioticImpact = resp.data.bioticImpact == true ? 1 : resp.data.bioticImpact == false ? 0 : undefined;
                        const valueSocioEnvironmental = resp.data.socioEnvironmental == true ? 1 : resp.data.socioEnvironmental == false ? 0 : undefined;
                        setSocialImpact(valueSocialImpact);
                        setPhysicalImpact(valuePhysicalImpact);
                        setBioticImpact(valueBioticImpact);
                        setSocioEnvironmental(valueSocioEnvironmental);
                    }
                })
            } catch (error: any) {
                toast.error(error);
            }
        }
    }

    const getPleaImpactsFiles = async () => {
        try {
            toggleLoading(true);
            await GetPleaImpactFilesById(state).then((resp: IResponseProps) => {
                if (resp.statusCode === 200) {
                    setFilesList(resp.data);
                }
            }).finally(() => {
                toggleLoading(false);
            });
        } catch (error: any) {
            toast.error(error);
            toggleLoading(false);
        }
    }
    const handleChangeselect = async (event: any, id: string) => {
        
        try {
            toggleLoading(true);
            await PleaImpactChangedSelect(id ?? "", event.target.value.toString(), state, companyId, userEmail).then((resp: IResponseProps) => {
                if (resp.statusCode === 200) {
                    toast.success({ message: `Alteração salva com sucesso !` });
                    if (id == "SocialImpact") {
                        setSocialImpact(parseInt(event.target.value));
                    } else if (id == "PhysicalImpact") {
                        setPhysicalImpact(parseInt(event.target.value));
                    } else if (id == "BioticImpact") {
                        setBioticImpact(parseInt(event.target.value));
                    } else if (id == "SocioEnvironmental") {
                        setSocioEnvironmental(parseInt(event.target.value));
                    }
                    navigate(`/plea/biological/${pleaId}/${id}`, { state: state });
                }
            }).finally(() => {
                toggleLoading(false);
            });
        }
        catch (error: any) {
            toast.error(error);
            toggleLoading(false);
        }

    };

    const sendFilePleaImpact = async () => {
        try {
            toggleLoading(true);
            if (state && files != null) {
                var resp = await UploadPleaImpact(files, urlPleaImpacts, userEmail, state)
                    .then((resp: IResponseProps) => { })
                    .finally(() => {
                        toggleLoading(false);
                        getPleaImpactsFiles();
                        toast.success({ message: `Upload feito com sucesso!` });
                    });
            }
        } catch (error: any) {
            toast.error(error);

            toggleLoading(false);
        }
    };
    const downloadFileById = async (id: string, fileName: string) => {
        try {

            await DownloadPleaImpactsFile(id).then((blobResp: any) => {
                var blob = new Blob([blobResp], {
                    type: 'application/octet-stream'
                });
                const fileURL = URL.createObjectURL(blob);
                const link = document.createElement("a");
                link.href = fileURL;
                link.setAttribute("download", fileName);
                document.body.appendChild(link);
                link.click();
                link.parentNode?.removeChild(link);
            });
        } catch (error: any) {
            toast.error(error);
        } finally {

        }
    }

    const deleteFile = async (fileId: string, fileName: string) => {
        try {
            toggleLoading(true)
            if (pleaId)
                await DeletePleaImpactsFile(companyId, encodeURIComponent(fileName), fileId, pleaId).then((resp: IResponseProps) => {
                    if (resp.statusCode == 200) {
                        getPleaImpactsFiles();
                    }
                }).finally(() => toggleLoading(false));
        } catch (error: any) {
            toggleLoading(false);
            toast.error(error.message);
        }
    }

    const props: UploadProps = {
        multiple: true,
        onChange(info) {
            const { status } = info.file;
                if (status !== 'uploading') {
                    const newFile = info.file.originFileObj;
                    if (newFile) {
    
                        setFiles(prevFiles => [...prevFiles, newFile]);
                    }
                }
                // if (status === 'error') {
                //     toast.error({ message: `${info.file.name} upload de arquivo falhou.` });
                // }
                if (status === 'removed') {
                    const removedFile = info.file.originFileObj;
                    if (removedFile) {
                        setFiles(prevFiles => prevFiles.filter(existingFile => existingFile.name !== removedFile.name));
                    }
                }
    
            },
        onDrop(e) {
        },
        onRemove(file) {
            setFiles(prevFiles => prevFiles.filter(existingFile => existingFile.name !== file.name));
        },
    };

    const columns: TableColumnsType = [
        {
            title: "Nome",
            dataIndex: "fileName",
            showSorterTooltip: { target: "full-header" },
            width: "40%",
            filters: filterExistingFields(filesList, "fileName"),
            onFilter: (value, record) => value === record.fileName,
            sorter: (a, b) => a.fileName.length - b.fileName.length,
        },
        {
            title: "Tamanho",
            dataIndex: "size",
            showSorterTooltip: { target: "full-header" },
            width: "25%",
            filters: filterExistingFields(filesList, "size"),
            onFilter: (value, record) => value === record.size,
            sorter: (a, b) => a.size - b.size,
        },
        {
            title: "Data do Upload",
            dataIndex: "created",
            showSorterTooltip: { target: "full-header" },
            width: "25%",
            render: (value) => {
              return (
                <div>
                  <Typography>{new Date(value).toLocaleDateString()}</Typography>
                </div>
              );
            },
        },
        {
            title: "Ações",
            dataIndex: "actions",
            align: "center",
            render: (value, record) => {
              return (
                <div className="column-action">
                  {
                    <>
                      <CloudDownloadOutlined
                        style={{ color: "#0000A4", cursor: "pointer" }}
                        size={20}
                        onClick={() => downloadFileById(record.id, record.fileName)}
                      />
                      <DeleteOutlined
                        style={{ color: "#FF0000", cursor: "pointer"}}
                        size={20}
                        onClick={() => {
                          deleteFile(record.id, record.fileName);
                        }}
                      />
                    </>
                  }
                </div>
              );
            },
            width: "10%",
            showSorterTooltip: { target: "full-header" },
        },
    ];

    useEffect(() => {
        getPleaImpacts();
        getPleaImpactsFiles();
    }, []);


    return (
      <>
      <div style={{ width: "100%", margin: "24px 0px" }}>
        <ModalPleaSocioEnvironmentalInfo show={dialogHelp} toggleShow={() => setDialogHelp(!dialogHelp)}/>

        <div style={{ display: 'flex', justifyContent: 'flex-end', width: '100%' }}>
            <QuestionCircleOutlined style={{ color: "var(--color-blue)", fontSize: "32px" , cursor: "pointer"}} onClick={() => setDialogHelp(true)}/>
        </div>

        <div style={{ display: "flex", flexWrap: "wrap" }}>
            <div style={{ width: "50%", boxSizing: "border-box" }}>
                {constructImpactModel({id: "SocialImpact",title: "Impacto Sociais", description:"O projeto gerará impactos negativos sociais negativos?", value: socialImpact })}
            </div>
            <div style={{ width: "50%", boxSizing: "border-box" }}>
                {constructImpactModel({id: "PhysicalImpact", title: "Impacto Meio Físico", description:" O projeto gerará impactos negativos no meio físico?",value: physicalImpact })}
            </div>
            <div style={{ width: "50%", boxSizing: "border-box" }}>
                {constructImpactModel({id: "BioticImpact",title: "Impacto Meio Biótico", description: "O projeto gerará impactos negativos no meio biótico?", value: bioticImpact})}
            </div>
            <div style={{ width: "50%", boxSizing: "border-box" }}>
                {constructImpactModel({id: "SocioEnvironmental", title: "Impacto Socioambientais Positivos", description: "O projeto gerará impactos positivos?", value: socioEnvironmental })}
            </div>
        </div>

        <div style={{ display: "flex", flexDirection: "column", margin: "16px 0px 0px 0px", width: "100%", gap: "16px" }}>
            <Typography style={{ color: "#000085", fontSize: "18px", margin: "0px 0px 10px 0px"}}>
                Documentos Ambientais e/ou Regulatórios
            </Typography>
          <div style={{ display: "flex",flexDirection: "column", gap: "10px"}}>
            <FIDragger props={props} />
            <Button style={{ alignSelf: "flex-end", width: "230px" }} size="large" onClick={() => { sendFilePleaImpact();}}>
              <FileImageOutlined />
              <Typography>Carregar Documentos</Typography>
            </Button>
          </div>

            <Table
            columns={columns}
            className={"table-min-height"}
            dataSource={filesList}
            pagination={{
                pageSizeOptions: [7, 10, 20, 30],
                defaultPageSize: 7,
            }}
            showSorterTooltip={{ target: "sorter-icon" }}
            />
        </div>
    </div>

    </>
    );
}